<template>
    <main class="sa-content sa-completed-detl">
      <div class="sa-card-large">
        <div class="sa-mob-header">
          <h5 class="sa-card-tit">Completed Order Details</h5>
          <button class="sa-btn-back" @click="$router.go(-1)">
            <i class="icon-arrow-left"></i>
          </button>
        </div>
        <div class="sa-mob-cont">
          <div class="sa-new-details">
            <AppointmentListCard />
            <HealthIssues />
          </div>
          <PatientDetails />
          <SummeryNote />
        </div>
      </div>
    </main>
  </template>
  <script>
  import AppointmentListCard from "../../components/nurse/AppointmentListCard.vue";
  import HealthIssues from "../../components/nurse/HealthIssues.vue";
  import PatientDetails from "../../components/nurse/PatientDetails.vue";
  import SummeryNote from "../../components/nurse/SummeryNote.vue";
  export default {
    components: { AppointmentListCard, HealthIssues, PatientDetails, SummeryNote },
    data() {
      return {
        open: false,
      };
    },
  };
  </script>
  